import { render, staticRenderFns } from "./pWareItem.vue?vue&type=template&id=1202c48c&scoped=true&"
import script from "./pWareItem.vue?vue&type=script&lang=js&"
export * from "./pWareItem.vue?vue&type=script&lang=js&"
import style0 from "./pWareItem.vue?vue&type=style&index=0&id=1202c48c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1202c48c",
  null
  
)

export default component.exports